import { Accordion } from '@doveit/lego';
import React, { FunctionComponent, useState } from 'react';
import PageSection from '../../../components/page-section/PageSection';
import { TextAlign, WrapperSize } from '../../../types';

export interface FaqItem {
  id: string,
  title: string,
  description: string,
}

export interface FaqProps {
  title: string,
  description?: string,
  items: FaqItem[],
}

const Faq: FunctionComponent<FaqProps> = ({
  title,
  description,
  items,
}) => {
  const [openItems, setOpenItems] = useState({});

  const onTitleClickHandler = (id) => {
    setOpenItems({
      ...openItems,
      [id]: !openItems[id],
    });
  };

  return (
    <PageSection backgroundColor="neutrals.lighter">
      <PageSection.Wrapper maxWidth={WrapperSize.M}>
        <PageSection.Title textAlign={TextAlign.CENTER}>
          {title}
        </PageSection.Title>

        {description && (
          <PageSection.Description text={description} textAlign={TextAlign.CENTER} />
        )}

        <PageSection.Block>
          <Accordion>
            {
              items.map((item) => (
                <Accordion.Item
                  key={item.id}
                  id={item.id}
                  title={item.title}
                  onTitleClick={onTitleClickHandler}
                  expanded={openItems[item.id]}
                >
                  <Accordion.ItemContent>
                    <div dangerouslySetInnerHTML={{ __html: item.description }} />
                  </Accordion.ItemContent>
                </Accordion.Item>
              ))
            }
          </Accordion>
        </PageSection.Block>
      </PageSection.Wrapper>
    </PageSection>
  );
};

export default Faq;
